/* 
* <license header>
*/

import React, { useEffect, useState } from 'react'
import { fetchStats } from './votingApi'

export default function SummaryPage () {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    async function load () {
      try {
        const data = await fetchStats()
        if (!cancelled && data) setStats(data)
      } catch (e) {
        console.error(e)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [])

  if (loading) {
    return (
      <div className="wv-loading">
        <p>Loading…</p>
      </div>
    )
  }

  return (
    <section className="wv-summary-panel">
      <h2 className="wv-section-title">Summary</h2>
      <div className="wv-summary-stats">
        <div>
          <p className="wv-stat-label">Total votes</p>
          <p className="wv-stat-value">{stats && stats.totalVotes != null ? stats.totalVotes : 0}</p>
        </div>
        {/* <div>
          <p className="wv-stat-label">People who voted</p>
          <p className="wv-stat-value">{stats && stats.uniqueVoters != null ? stats.uniqueVoters : 0}</p>
        </div> */}
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="wv-table">
          <thead>
            <tr>
              <th>City</th>
              <th className="wv-th-right">Venue</th>
              <th className="wv-th-right">Ticket Price</th>
              <th className="wv-th-right">Votes</th>
            </tr>
          </thead>
          <tbody>
            {(stats && stats.items ? stats.items : []).map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td className="wv-td-right">{item.venue}</td>
                <td className="wv-td-right">${item.ticketPrice}</td>
                <td className="wv-td-right">{item.votes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
